<template>
    <div>
        <div v-cloak v-show="loading">
            <div v-for="index in 5" :key="index" class="my-3 h-12 placeholder-media w-full sm:w-2/4 md:w-2/4">
                <div class="line my-2"></div>
            </div>
        </div>

        <div v-cloak v-show="!loading">
            <div v-cloak v-show="!emptyStores">
                <div class="flex flex-wrap justify-center">
                    <store-item v-for="store in stores" :key="store.id" :store="store" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({
        stores: [],
        loading: false
    }),

    created() {
        this.fetchStores();
    },

    mounted() {},

    watch: {
        // stores: {
        //     handler() {},
        //     deep: true
        // }
    },

    computed: {
        emptyStores() {
            return this.stores.length == 0;
        }
    },

    methods: {
        fetchStores() {
            this.loading = true;

            axios
                .get("/api/stores", {
                    params: {
                        featured: 1
                    }
                })
                .then(response => {
                    this.stores = response.data;
                })
                .catch(response => {})
                .finally(() => {
                    this.loading = false;
                });
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
